/**
 * 根据当前 pathname 计算顶部与左侧侧边栏应选中的菜单项 key。
 *
 * 在 splitMenus（一级导航在顶部、二级导航在左侧）模式下：
 * 返回数组的第一个元素为一级菜单 key（供 splitMenus 定位当前一级并渲染其子菜单，同时高亮顶部栏），
 * 后续元素为二级菜单 key（高亮左侧侧边栏具体项）。
 * 若一级导航下无二级导航，则只返回一级菜单 key，左侧侧边栏自动隐藏。
 */
export const getSelectedMenuKeys = (pathname: string): string[] => {
  if (!pathname || pathname === '/' || pathname === '/home') {
    return ['/workbench'];
  }

  // 1. 客户与人脉
  if (
    pathname === '/relations' ||
    pathname === '/organizations' ||
    pathname.startsWith('/relations/organizations') ||
    pathname.startsWith('/organizations/') ||
    pathname.startsWith('/resources/suppliers')
  ) {
    return ['/relations', '/relations/organizations'];
  }
  if (
    pathname === '/contacts' ||
    pathname.startsWith('/relations/contacts') ||
    pathname.startsWith('/contacts/')
  ) {
    return ['/relations', '/relations/contacts'];
  }

  // 2. 技术需求
  if (
    pathname === '/technical-needs' ||
    pathname === '/leads' ||
    pathname.startsWith('/technical-needs/leads') ||
    pathname.startsWith('/leads/')
  ) {
    return ['/technical-needs', '/technical-needs/leads'];
  }
  if (
    pathname === '/demands' ||
    pathname.startsWith('/technical-needs/demands') ||
    pathname.startsWith('/demands/')
  ) {
    return ['/technical-needs', '/technical-needs/demands'];
  }

  // 3. 技术资源
  if (
    pathname === '/resources' ||
    pathname.startsWith('/resources/experts')
  ) {
    return ['/resources', '/resources/experts'];
  }
  if (pathname.startsWith('/resources/technologies')) {
    return ['/resources', '/resources/technologies'];
  }

  // 4. 业务转化
  if (
    pathname === '/business-conversion' ||
    pathname.startsWith('/business-conversion/matchmaking') ||
    pathname === '/resources/matchmaking'
  ) {
    return ['/business-conversion', '/business-conversion/matchmaking'];
  }
  if (
    pathname.startsWith('/business-conversion/engagements') ||
    pathname.startsWith('/engagements')
  ) {
    return ['/business-conversion', '/business-conversion/engagements'];
  }
  if (
    pathname === '/opportunities' ||
    pathname.startsWith('/business-conversion/opportunities') ||
    pathname.startsWith('/opportunities/')
  ) {
    return ['/business-conversion', '/business-conversion/opportunities'];
  }
  if (
    pathname === '/conversion-businesses' ||
    pathname.startsWith('/business-conversion/conversion-businesses') ||
    pathname.startsWith('/conversion-businesses/')
  ) {
    return ['/business-conversion', '/business-conversion/conversion-businesses'];
  }

  // 5. 设置
  if (
    pathname === '/settings' ||
    pathname === '/settings/business' ||
    pathname === '/profile/settings' ||
    pathname === '/profile/settings/business'
  ) {
    return ['/settings', '/settings/business'];
  }
  if (
    pathname.startsWith('/settings/model') ||
    pathname.startsWith('/profile/settings/model')
  ) {
    return ['/settings', '/settings/model'];
  }
  if (
    pathname.startsWith('/settings/data-management') ||
    pathname.startsWith('/profile/settings/data-management') ||
    pathname.includes('mock-data')
  ) {
    return ['/settings', '/settings/data-management'];
  }
  if (
    pathname.startsWith('/settings/permissions') ||
    pathname.startsWith('/profile/settings/permissions')
  ) {
    return ['/settings', '/settings/permissions'];
  }

  // 6. 其他独立页面（无二级导航，左侧侧边栏自动隐藏）
  if (pathname.startsWith('/workbench')) {
    return ['/workbench'];
  }
  if (pathname.startsWith('/activities')) {
    return ['/activities'];
  }
  if (pathname.startsWith('/dashboard')) {
    return ['/dashboard'];
  }
  if (pathname.startsWith('/profile')) {
    return ['/profile'];
  }

  return [pathname];
};
